import React, { ReactNode } from 'react';

import { createTheme } from '@material-ui/core';
import { ThemeOptions } from '@material-ui/core/styles/createTheme';
import { ThemeProvider as MuiThemeProvider } from '@material-ui/styles';

import { getThemeByName } from './themes/base';

type OuterProps = {
  children: ReactNode;
  themeName: WebOrderTheme;
  fontName: string;
};

// eslint-disable-next-line react/function-component-definition
const ThemeProvider = (props: OuterProps) => {
  const { children, themeName, fontName } = props;
  const currentTheme = getThemeByName(themeName, fontName);

  return <MuiThemeProvider theme={currentTheme}>{children}</MuiThemeProvider>;
};

export default ThemeProvider;

export type WebOrderTheme = 'budapest' | 'loading';

export const createWebOrderTheme = (props?: ThemeOptions) => createTheme(props);
